import { Box } from "@material-ui/core";
import InfoDivider from "../../../../components/InfoDivider";
import { SelectableValue } from "../../../../models/common/selectable-value";
import AgreementSpecificRolesAction from "./AgreementSpecificRolesAction";
import DefaultAgreementRolesAction from "./DefaultAgreementRolesAction";
import OperativeDataAction from "./OperativeDataAction";
import useOrganizationStyles from "../use-organization-styles";
import { GetUserDomainsTreeQuery } from "../types/queries.generated";

export interface OrganizationActionProps {
	orgId: string;
	domainOptionsTree: GetUserDomainsTreeQuery["GetUserDomainsTree"];
	domainOptions: Array<SelectableValue>;
	selectedUsers: Array<SelectableValue>;
	selectedTags: Array<SelectableValue>;
	selectedDomains: Array<SelectableValue>;
}

const OrganizationActionSettings: React.FC<OrganizationActionProps> = ({
	orgId,
	domainOptionsTree,
	domainOptions,
	selectedUsers,
	selectedTags,
	selectedDomains,
}) => {
	const { organizationActionSettingsContainer } = useOrganizationStyles();

	return (
		<Box className={organizationActionSettingsContainer}>
			<InfoDivider paddingX={2} paddingTop={0} title="general-configuration" />
			<OperativeDataAction
				orgId={orgId}
				domainOptions={domainOptions}
				selectedUsers={selectedUsers}
				selectedTags={selectedTags}
				selectedDomains={selectedDomains}
				domainOptionsTree={domainOptionsTree}
			/>
			<InfoDivider paddingX={2} paddingTop={5} title="default-agreement-roles" />
			<DefaultAgreementRolesAction orgId={orgId} selectedUsers={selectedUsers} selectedTags={selectedTags} />
			<InfoDivider paddingX={2} paddingTop={5} title="agreement-specific-roles" />
			<AgreementSpecificRolesAction orgId={orgId} selectedUsers={selectedUsers} selectedTags={selectedTags} />
		</Box>
	);
};

export default OrganizationActionSettings;
